










































































































































































import mixins from 'vue-typed-mixins';
import { MultipleChoiceOptions } from '.';

export default mixins().extend({
  props: {
    value: {
      type: Object as () => MultipleChoiceOptions,
    },
  },
  mounted() {
    // set  values to defaults if not set
    this.$emit('input', {
      type: this.value.type || 'dropdown',
      multiple: this.value.multiple || false,
      sort: this.value.sort || 'manual',
      other: this.value.other || false,
      otherlabel:
        this.value.otherlabel ||
        this.$languageobj(
          'model.question.options.multiple_choice.other.default'
        ),
      displayalloptions: this.value.displayalloptions || false,
      notes: this.value.notes || false,
      noteslabel:
        this.value.noteslabel ||
        this.$languageobj(
          'model.question.options.multiple_choice.notes.default'
        ),
      choices: this.value.choices
        ? this.value.choices.map((choice) => ({
            // do formatting of the choices to make sure it has at least the correct structure
            key: choice.key,
            shorttext:
              choice.shorttext || (choice as any).text || this.$languageobj(), // check .text just to copy existing multiple choice to the new format
            longtext: choice.longtext || this.$languageobj(),
          }))
        : [],
    });
  },
  methods: {
    create() {
      this.value.choices.push({
        shorttext: this.$languageobj(),
        longtext: this.$languageobj(),
        key: '',
      });
    },
  },
});
